import type { EventDto } from '@/types/dtos/events/response/event.dto';
import type { FlowDto } from '@/types/dtos/flows/response/flow.dto';
import type { SessionDto } from '@/types/dtos/sessions/session.dto';
import type { RoleDto } from '@/types/dtos/contributors/response/contributor.dto';

export const getEntityName = ({ entity, entityType }: Pick<RoleDto, 'entity' | 'entityType'>) => {
  // Handle undefined entity
  if (!entity) {
    return '-';
  }

  // If entity is a string ID, return a placeholder name
  if (typeof entity === 'string') {
    return `${entityType} (${entity.slice(-8)})`; // Show last 8 chars of ID
  }

  // If entity is an object, return its title or create a placeholder if no title
  switch (entityType) {
    case 'Event':
      return (entity as EventDto).title || `Event (${entity.id?.slice(-8) || 'unknown'})`;
    case 'Flow':
      return (entity as FlowDto).title || `Flow (${entity.id?.slice(-8) || 'unknown'})`;
    case 'Session':
      return (entity as SessionDto).title || `Session (${entity.id?.slice(-8) || 'unknown'})`;
    default:
      return '-';
  }
};
